// @ts-nocheck
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import { Text, XStack, YStack } from 'tamagui';

import { useIsMobile } from '../../hooks/useIsMobile';
import { useMotion } from '../../hooks/useMotion';
import { SECURITY_FEATURES } from './constants';

/**
 * ARRANGE: Inline feature list instead of centered card grid.
 * Left-aligned, compact, no cards — just icon + title + description in a row.
 * Feels like a spec sheet, not a marketing section.
 */
export function Security() {
  const isMobile = useIsMobile();
  const { sectionReveal } = useMotion();
  const navigate = useNavigate();

  return (
    <YStack
      paddingVertical={isMobile ? 80 : 100}
      paddingHorizontal="$5"
      backgroundColor="$color2"
      borderTopWidth={1}
      borderBottomWidth={1}
      borderColor="$borderColor"
    >
      <YStack maxWidth={800} alignSelf="center" width="100%">
        <motion.div
          {...sectionReveal}
          viewport={{ once: true, margin: '-100px' }}
        >
          <YStack gap="$3" marginBottom="$8">
            <Text
              fontSize="$2"
              fontWeight="600"
              color="$color7"
              textTransform="uppercase"
              letterSpacing={1.5}
            >
              Enterprise ready
            </Text>
            <Text
              fontSize={isMobile ? 30 : 40}
              fontWeight="700"
              letterSpacing={-1.5}
              lineHeight={isMobile ? 36 : 48}
              color="$color12"
            >
              Built for security from day one
            </Text>
          </YStack>
        </motion.div>

        {/* 2-column inline features — no cards */}
        <XStack
          flexWrap="wrap"
          gap={isMobile ? '$6' : '$8'}
          flexDirection={isMobile ? 'column' : 'row'}
        >
          {SECURITY_FEATURES.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08, duration: 0.4, ease: [0.25, 1, 0.5, 1] }}
              style={{ width: isMobile ? '100%' : 'calc(50% - 16px)' }}
            >
              <XStack gap="$3" alignItems="flex-start">
                <item.icon size={20} color="var(--accentBackground)" style={{ flexShrink: 0, marginTop: 2 }} />
                <YStack gap="$1">
                  <Text fontSize={16} fontWeight="600" color="$color12">
                    {item.title}
                  </Text>
                  <Text fontSize={14} color="$color8" lineHeight={22}>
                    {item.desc}
                  </Text>
                </YStack>
              </XStack>
            </motion.div>
          ))}
        </XStack>

        <XStack
          alignItems="center"
          gap="$2"
          marginTop="$6"
          cursor="pointer"
          onPress={() => navigate('/security')}
          hoverStyle={{ opacity: 0.8 }}
        >
          <Text fontSize={14} fontWeight="500" color="$accentBackground">
            Learn more about our security model
          </Text>
          <ArrowRight size={14} color="var(--accentBackground)" />
        </XStack>
      </YStack>
    </YStack>
  );
}
